import React, { useState } from 'react'

const Alert = ({ message }) => {
    const [close, setClose] = useState(false);
    const onClose = () => {
        setClose(true);
    }
    return (
        <div>
            <div
                className={`bg-red-50 my-4 border-l-4 border-red-500 text-red-800 px-6 py-4 rounded-r-lg shadow-md transition-all duration-300 ease-in-out ${close ? 'hidden' : 'block'
                    }`}
                role="alert"
            >
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                        <svg
                            className="h-6 w-6 text-red-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>
                        <div>
                            <span className="block sm:inline ml-1 text-sm sm:text-base">{message}</span>
                        </div>
                    </div>
                    <button
                        className="text-red-500 hover:text-red-700 transition-colors duration-200"
                        onClick={onClose}
                        aria-label="Fermer l'alerte"
                    >
                        <svg
                            className="h-5 w-5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Alert